export { default } from "./PushMessage.vue"
